<template>
  <v-card
    :height="widgetHeight"
    :min-width="widgetWidth"
    :color="settingsModel.color"
    class="ma-0 pa-0"
    :loading="loading"
  >
    <v-img
      :src="settingsModel.image"
      class="white--text"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      :height="widgetHeight"
      :min-width="widgetWidth"
    >
      <v-card-title v-if="!loading" class="pa-0 ma-0 pt-1">
        <v-icon :color="settingsModel.textColor">mdi-bookmark-outline</v-icon>
        <v-spacer />
        <div style="height: 15px">
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container class="py-0">
          <v-row no-gutters justify="center" align="center">
            <v-btn
              :disabled="enableEdit"
              text
              style="text-transform: none !important"
              :color="settingsModel.textColor"
              v-if="url"
              :link="true"
              :target="settingsModel.target"
              :href="settingsModel.bookmarkType > 0 ? '' : url"
              :to="settingsModel.bookmarkType > 0 ? url : ''"
            >
              <v-icon large class="mr-2">{{ settingsModel.icon }}</v-icon>
              {{ settingsModel.description }}
            </v-btn>
          </v-row>
        </v-container>
        <widget-settings-modal :ref="modalKey" @on-save="onSettingsSave" />
      </v-card-text>
    </v-img>
  </v-card>
</template>

<script>
import WidgetSettingsModal from '@/components/widgets/WidgetSettingsModal';
import WidgetSettings from '@/ecm/models/WidgetSettings';
import WidgetType from '@/ecm/variables/WidgetType';
import SearchType from '@/ecm/variables/SearchType';

export default {
    components: { WidgetSettingsModal },
    name: 'WidgetBookmark',
    props: {
        widgetId: {
            type: Number,
            default: 0,
        },
        enableEdit: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: 0,
        },
        height: { type: Number, default: 0 },
        width: { type: Number, default: 0 },
        settings: { type: Object },
    },
    mounted() {
        this.widgetHeight = this.height;
        this.widgetWidth = this.width;
        this.settingsModel = new WidgetSettings(this.widgetId, this.settings);
    },
    data() {
        return {
            loading: false,
            widgetHeight: 0,
            widgetWidth: 0,
            settingsModel: new WidgetSettings(),
            modalKey: 'modalSettingsKey',
        };
    },
    computed: {
        modalSettings() {
            return this.$refs[this.modalKey];
        },
        url() {
            if (this.settingsModel.bookmarkType > 0) {
                let route = 'search/';

                switch (this.settingsModel.bookmarkType) {
                case WidgetType.Baskets:
                    route += `${SearchType.Basket}/${this.settingsModel.url}`;
                    break;
                case WidgetType.UserSearches:
                    route += `${SearchType.UserSearch}/${this.settingsModel.url}`;
                    break;
                case WidgetType.Distributions:
                    route += `${SearchType.Distribution}/${this.settingsModel.url}`;
                    break;
                }

                return route;
            }
            return this.settingsModel.url;
        },
    },
    methods: {
        resize(height, width) {
            this.widgetHeight = height;
            this.widgetWidth = width;
        },
        showSettings() {
            this.modalSettings.show(
                this.id,
                this.widgetId,
                this.settingsModel.toDto()
            );
        },
        onSettingsSave(dto) {
            this.settingsModel = new WidgetSettings(this.widgetId, dto);
        },
        removeWidget() {
            this.$emit('on-remove-widget', this.id);
        },
    },
};
</script>
